const state = {
  name: "",
  build: "",
};

const getters = {
  getName: (state) => state.name,
  getBuild: (state) => state.build,
};

const actions = {
  updateName: ({ commit }, newName) => {
    commit("setName", newName);
  },
  updateBuild: ({ commit }, newName) => {
    commit("setBuild", newName);
  },
};

const mutations = {
  setName: (state, newName) => {
    state.name = newName;
  },
  setBuild: (state, newBuild) => {
    state.build = newBuild;
  },
};

export const app = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
